<template>

  <v-list two-line v-if="polls && polls.length > 0">
    <v-list-item v-for="poll in polls" :key="poll.id" :to="{ name: 'poll', params: { id: poll.id } }">
      <v-list-item-avatar>
        <v-icon size="24">
          {{ icons.mdiPoll }}
        </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="mb-1 text-lg">
          {{ poll.title }}</v-list-item-title>
        <v-list-item-subtitle>
          {{
            $t("Vastausaika päättyy") + " " + getDateTime(poll.expire_date)
          }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>
          <v-chip small>
            {{ poll.group_name }}
          </v-chip>
        </v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>
  </v-list>


</template>

<script>
import { getDateTime } from "@/@core/utils/datetime_helpers";
import { mdiPoll } from "@mdi/js";

export default {
  props: ["polls"],
  setup() {
    return {
      getDateTime,
      icons: {
        mdiPoll,
      },
    };
  },
};
</script>

<style></style>
